import { qs, qsa, listen } from '@fluorescent/dom';

const {
  strings: { accessibility: strings },
} = window.theme;

const handleTab = () => {
  let tabHandler = null;
  const formElments = ['INPUT', 'TEXTAREA', 'SELECT'];
  // Determine if the user is a mouse or keyboard user
  function handleFirstTab(e) {
    if (
      e.keyCode === 9 &&
      !formElments.includes(document.activeElement.tagName)
    ) {
      document.body.classList.add('user-is-tabbing');

      tabHandler();
      tabHandler = listen(window, 'mousedown', handleMouseDownOnce);
    }
  }

  function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');

    tabHandler();
    tabHandler = listen(window, 'keydown', handleFirstTab);
  }

  tabHandler = listen(window, 'keydown', handleFirstTab);
};

const focusFormStatus = node => {
  const formStatus = qs('.form-status', node);

  if (!formStatus) return;

  const focusElement = qs('[data-form-status]', formStatus);

  focusElement.focus();
};

const prefersReducedMotion = () => {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

function backgroundVideoHandler(container) {
  const pause = qs('.video-pause', container);
  const video = container.getElementsByTagName('VIDEO')[0];

  if (!pause || !video) return;

  const pauseListener = listen(pause, 'click', e => {
    e.preventDefault();

    if (video.paused) {
      video.play();
      pause.innerText = strings.pause_video;
    } else {
      video.pause();
      pause.innerText = strings.play_video;
    }
  });

  return () => pauseListener();
}

function disableLinks(links) {
  links.forEach(link => {
    link.setAttribute('tabindex', -1);
  });
}

function enableLinks(links) {
  links.forEach(link => {
    link.setAttribute('tabindex', 0);
  });
}

function disableLinksWithin(wrappingEl) {
  const links = qsa('a', wrappingEl);
  disableLinks(links);
}

function enableLinksWithin(wrappingEl) {
  const links = qsa('a', wrappingEl);
  enableLinks(links);
}

function syncTabIndexesOnFlickity(flickityInstance) {
  // This ensures that all non active items have
  // a tabindex of -1 and that active items do not
  flickityInstance.slides.forEach(slide => {
    disableLinksWithin(slide.cells[0].element);
  });
  enableLinksWithin(flickityInstance.selectedElement);
}

export {
  handleTab,
  focusFormStatus,
  prefersReducedMotion,
  backgroundVideoHandler,
  disableLinks,
  enableLinks,
  disableLinksWithin,
  enableLinksWithin,
  syncTabIndexesOnFlickity
};
